// extracted by mini-css-extract-plugin
export default {"body":"styles_body__uMAZS","viewBtn":"styles_viewBtn__wmpRe","btnSubmit":"styles_btnSubmit__F2Y1S"};